module.exports = __webpack_public_path__ + "static/media/img_panel_passive.bb8fe9e1.jpg";